import * as CMExports from './cm';
import * as GDExports from './gd';
import * as TPExports from './tp';
import * as WBExports from './wb';

export const ModulesApiRoutes = {
    gd: GDExports.APIRoutes,
    wb: WBExports.APIRoutes,
    tp: TPExports.APIRoutes,
    cm: CMExports.APIRoutes,
};

export const ModulesRoutes = {
    gd: GDExports.Routes,
    wb: WBExports.Routes,
    tp: TPExports.Routes,
    cm: CMExports.Routes,
};

export const ModulesIntents = {
    gd: GDExports.Intents,
    wb: WBExports.Intents,
    tp: TPExports.Intents,
    cm: CMExports.Intents,
};

export const ModulesSettings = {
    gd: GDExports.Settings,
    wb: WBExports.Settings,
    tp: TPExports.Settings,
    cm: CMExports.Settings,
};
